<soft-ds-card
  density="compact"
  class="group cursor-pointer"
  (click)="goToApplication(application)"
>
  <div class="flex flex-row items-center gap-3">
    <span
      class="rounded-xl min-w-16 min-h-16 text-center items-center content-center justify-center"
      [class]="
        showColor() && application?.color && !application?.disabled
          ? application?.color
          : 'bg-surface-tertiary dark:bg-surface-muted text-color'
      "
    >
      @if (application?.icon !== '') {
        <soft-icon
          [name]="$safeNavigationMigration(application?.icon)"
          class="fa-2x"
          [class]="application?.disabled ? 'text-lighter' : ''"
        />
      } @else {
        <i class="fa-regular fa-ban fa-3x"></i>
      }
    </span>
    <div class="flex flex-col w-full">
      <span
        class="font-bold text-lg"
        [class]="application?.disabled ? 'text-lighter' : ''"
      >
        {{ $safeNavigationMigration(application?.name) | translate }}
      </span>

      @if (application?.description) {
        <p class="color-light">
          {{ $safeNavigationMigration(application?.description) | translate }}
        </p>
      }
    </div>
    <div class="flex flex-row justify-center items-center gap-1">
      @if (canPin()) {
        <button
          type="button"
          class="opacity-0 group-hover:opacity-100 flex items-center justify-center size-8 rounded-md hover:bg-surface-tertiary transition-opacity cursor-pointer"
          [class.opacity-100]="pinned()"
          [class.text-primary]="pinned()"
          (click)="pinChange.emit(!pinned()); $event.stopPropagation()"
          [title]="pinned() ? 'Aus Navigation entfernen' : 'An Navigation anheften'"
        >
          <i
            class="fa-thumbtack text-sm transition-transform"
            [class.fa-solid]="pinned()"
            [class.fa-regular]="!pinned()"
            [class.rotate-45]="pinned()"
          ></i>
        </button>
      }
      <button
        type="button"
        class="opacity-0 group-hover:opacity-100 flex items-center justify-center size-8 rounded-md hover:bg-surface-tertiary transition-opacity cursor-pointer"
        (click)="openInNewTab(application, $event)"
        title="In neuem Tab öffnen"
      >
        <i class="fa-regular fa-arrow-up-right-from-square text-sm"></i>
      </button>
    </div>
  </div>
</soft-ds-card>
